import { render, staticRenderFns } from "./DServerPassword.vue?vue&type=template&id=164a7ba8&"
import script from "./DServerPassword.vue?vue&type=script&lang=js&"
export * from "./DServerPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164a7ba8')) {
      api.createRecord('164a7ba8', component.options)
    } else {
      api.reload('164a7ba8', component.options)
    }
    module.hot.accept("./DServerPassword.vue?vue&type=template&id=164a7ba8&", function () {
      api.rerender('164a7ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Dedicated/DServerPassword.vue"
export default component.exports